module.exports = __webpack_public_path__ + "static/media/cv-webpage.9f83f161.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cv-webpage.png
// module id = 221
// module chunks = 0